import { Component, AfterViewInit, inject, viewChild, effect, computed, signal } from '@angular/core';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';


import { MedicRegistru } from '../../shared/models/cautare.model';
import { CautareService } from '../../shared/services/cautare.service';
import { RegistreService } from '../../shared/services/registre.service';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatList, MatListItem } from '@angular/material/list';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { JudetPipe } from '../../shared/pipes/judet.pipe';
import { MedicStatusPipe } from '../../shared/pipes/status.pipe';
import { CautareStore } from '../../shared/state/cautare.store';

@Component({
    selector: 'app-rezultat-cmr',
    templateUrl: './rezultat-cmr.component.html',
    styleUrls: ['./rezultat-cmr.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, MatList, MatListItem, MatIconButton, MatIcon, MatButton, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, JudetPipe, MedicStatusPipe]
})
export class RezultatCmrComponent implements AfterViewInit {
  private cautareMedic = inject(CautareService);
  private readonly cautareStore = inject(CautareStore);
  regServ = inject(RegistreService);


  displayedColumns = ['status_icon', 'judet', 'status', 'nume', 'prenume', 'nume_anterior', 'cuim', 'cnp'];

  dataSource = new MatTableDataSource<MedicRegistru>();

  protected readonly selectedRowIndex = signal<string | number>(-1);
  // paginarea vine din raspunsul cautarii (links next/prev de forma ...?page=N)
  private readonly lista = this.cautareStore.listaCmr;
  protected readonly total = computed(() => this.lista()?.total ?? NaN);
  protected readonly pagini = computed(() => this.lista()?.pages ?? NaN);
  protected readonly nextPage = computed(() => this.lista()?.next ?? '');
  protected readonly prevPage = computed(() => this.lista()?.prev ?? '');
  protected readonly currentPage = computed(() => {
    const lista = this.lista();
    // fara rezultate nu se afiseaza nimic (NaN nu trece de nicio comparatie)
    if (lista == null) {
      return NaN;
    }
    const prevPg = lista.prev.match(/=\s*(.*)$/);
    const nextPg = lista.next.match(/=\s*(.*)$/);
    return Number(nextPg?.[1]) === 2 ? 1 : Number(prevPg?.[1]) + 1;
  });
  private readonly incarcaTabel = effect(() => {
    const lista = this.lista();
    if (lista != null) {
      this.dataSource.data = lista.results;
    }
  });

  readonly sort = viewChild(MatSort);


  ngAfterViewInit() {
    this.dataSource.sort = this.sort();
  }

  doFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLocaleLowerCase();
  }

  clickRow(row: MedicRegistru) {
    this.selectedRowIndex.set(row.id);
  }

  getNewPage(searchVal: string, searchType: string) {
    this.cautareMedic.cautaMedic(searchVal, searchType);
  }

  getColor(statusId: number) {

    if ([1, 3].includes(statusId)) {
      return 'primary';
    }

    if ([2].includes(statusId)) {
      return 'accent';
    }

    return 'warn';
  }
}
